import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const TrashIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 14 18"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="delete" fill="none" fillRule="evenodd">
      <g fill={fillColor} fillRule="nonzero">
        <g>
          <path d="M1.11428571,5.87142857 L12.6,5.87142857 C13.2428571,5.7 13.7142857,5.12142857 13.7142857,4.41428571 L13.7142857,3.94285714 C13.7142857,3.10714286 13.05,2.44285714 12.2142857,2.44285714 L9.98571429,2.44285714 C9.98571429,1.17857143 8.95714286,0.15 7.69285714,0.15 L6.04285714,0.15 C4.77857143,0.15 3.75,1.17857143 3.75,2.44285714 L1.5,2.44285714 C0.664285714,2.44285714 0,3.10714286 0,3.94285714 L0,4.41428571 C0,5.12142857 0.471428571,5.7 1.11428571,5.87142857 Z M6.02142857,1.45714286 L7.67142857,1.45714286 C8.22857143,1.45714286 8.67857143,1.90714286 8.67857143,2.46428571 L5.01428571,2.46428571 C5.03571429,1.90714286 5.48571429,1.45714286 6.02142857,1.45714286 Z" />
          <path d="M4.02857143,17.8285714 L9.68571429,17.8285714 C11.2285714,17.8285714 12.4714286,16.5857143 12.4714286,15.0428571 L12.4714286,6.94285714 L1.24285714,6.94285714 L1.24285714,15.4714286 C1.24285714,16.5642857 2.50714286,17.8285714 4.02857143,17.8285714 Z M8.63571429,9.40714286 L9.92142857,9.40714286 L9.92142857,14.9785714 L8.63571429,14.9785714 L8.63571429,9.40714286 Z M6.21428571,9.40714286 L7.5,9.40714286 L7.5,14.9785714 L6.21428571,14.9785714 L6.21428571,9.40714286 Z M3.79285714,9.40714286 L5.07857143,9.40714286 L5.07857143,14.9785714 L3.79285714,14.9785714 L3.79285714,9.40714286 Z" />
        </g>
      </g>
    </g>
  </svg>
);

TrashIcon.defaultProps = defaultProps;

export default TrashIcon;
